const SHARE_TYPE = 'SHARE';


















function isBufferConsumed({ credit, topUpCredit, bufferRemaining, creditCost }) {
  if (credit + bufferRemaining >= creditCost) {
    const pendingAmount = credit - creditCost >= 0 ?
    creditCost :
    credit;

    const bufferToBeConsumed = creditCost - pendingAmount;

    return bufferToBeConsumed > 0;
  }

  if (credit + topUpCredit + bufferRemaining >= creditCost) {
    const totalCredits = credit + topUpCredit;
    const pendingAmount = totalCredits - creditCost >= 0 ?
    creditCost :
    totalCredits;

    const bufferToBeConsumed = creditCost - pendingAmount;

    return bufferToBeConsumed > 0;
  }

  return false;
}

export default function showBufferCreditWarning({
  orgCreditInfo,
  teamCreditInfo,
  selectedTeamId,
  creditCost = 1
}) {
  const {
    package: { creditType } = {},
    creditBalance: { balance, credit, topUpCredit, bufferRemaining } = {}
  } = orgCreditInfo;

  if (balance === Infinity) {
    return false;
  }

  if (creditType === SHARE_TYPE) {
    return isBufferConsumed({ credit, topUpCredit, bufferRemaining, creditCost });
  }

  if (!teamCreditInfo.length) {
    return false;
  }

  const allocatedCreditsForSelectedTeam = teamCreditInfo.
  find((t) => t.team.teamId === selectedTeamId);

  const {
    credit: teamCredit,
    topUpCredit: teamTopUpCredit,
    bufferRemaining: teamBufferRemaining
  } = allocatedCreditsForSelectedTeam?.team?.creditBalance || {};

  return isBufferConsumed({
    credit: teamCredit,
    topUpCredit: teamTopUpCredit,
    bufferRemaining: teamBufferRemaining,
    creditCost
  });
}